module.exports = __webpack_public_path__ + "static/media/galerija_2021 (2).2d28a8f1.jpg";